// Feedback card layouts: avatar-left or avatar-right
export const LAYOUT_CONFIG = {
  'avatar-left': {
    profileSize: 300,
    profileBorderWidth: 10,
    profileDirection: 'left' as const,
    quotationPosition: 'bottom-right' as const,
    quotationSize: 'default' as const,
    contentAlign: 'left' as const,
  },
  'avatar-right': {
    profileSize: 300,
    profileBorderWidth: 10,
    profileDirection: 'right' as const,
    quotationPosition: 'left' as const,
    quotationSize: 'large' as const,
    contentAlign: 'right' as const,
  },
};

/** Duration in frames for the scene-level fade-in */
export const SCENE_FADE_IN_DURATION = 25;

export const TIMING = {
  CONTAINER: { startFrame: 5, durationInFrames: 20 },
  PROFILE_IMAGE: { startFrame: 15, distance: 120 },
  NAME: { startFrame: 20, stagger: 10 },
  QUOTE: { startFrame: 45, charsPerFrame: 2 },
  QUOTATION_MARKS: { startFrame: 30 },
  TRANSITION_DURATION: 12,
};

export const HOLD_DURATION_AFTER_COMPLETE = 75; // Hold duration after content completes (2.5 seconds at 30fps);
export const MIN_FEEDBACK_DURATION = 90; // Minimum feedback card duration (3 seconds at 30fps);
export const TOPIC_LABEL_DELAY_FRAMES = 10; // Delay before showing topic label after quote finishes (~0.33 seconds at 30fps);
export const MAX_DISPLAY_FEEDBACKS = 3;
export const LAST_FEEDBACK_EXTRA_HOLD = 15; // Extra hold on last item to compensate for scene transition (~0.5s at 30fps)
